import Vue from 'vue';

export class ServerStatistics {

  public static getStatistics(exhibitor : any): Promise<any> {
    return new Promise((resolve) => {
      Vue.axios({
        url: `/web/statistics/${exhibitor}`,
        method: 'GET',
      })

      .then(resp => resolve(resp))
      .catch(err => console.log(err))
    })
  }

}